module.exports = "/_next/static/images/63bf289ff027d202b57a3c321a05d9e8-yield-lg.png.webp";